import { getDomain } from '../../../../components/http/http'

let config: any = {};

export const getConfig = (key: string, defaultValue: any) => {
  return config[key] || defaultValue;
};

export const setConfig = (newConfig: any) => {
  config = newConfig;
};

export const resolveUploadUrl = (url: string | null | undefined): string => {
  if (!url) return ''
  if (/^https?:\/\//i.test(url)) return url
  const domain = getDomain()
  const base = domain.endsWith('/') ? domain.slice(0, -1) : domain
  const result = url.startsWith('/') ? `${base}${url}` : `${base}/${url}`
  return result
}

export const fixUploadUrlsInHtml = (html: string): string => {
  if (!html || typeof html !== 'string') return html
  const result = html.replace(
    /src="(\/uploads\/[^"]*)"/gi,
    (_match: string, path: string) => {
      const full = resolveUploadUrl(path)
      return `src="${full}"`
    }
  )
  return result
}
